// import React, { useCallback, useEffect, useState } from "react";
// import ProcessLayout from "../Common/ProcessLayout";
// import { API_URL } from "../../imports";
// import axios from "axios";
// import GetIdeasFilewiseStatusLogs from "./GetIdeasComponents/GetIdeasFilewiseStatusLogs";
// import FilesToProcess from "../Common/FilesToProcess";
// import Process from "../Common/Process";
// import CurrentProcessLogs from "../Common/CurrentProcessLogs";
// import Popup from "../Common/Popup";
// import { handleApiError } from "../Common/APIUtils";
// import { formattedStartDateTime } from "../Common/CommonUtils";

// function GetIdeas() {
//     const [startProcess, setStartProcess] = useState(false);
//     const [backgroundProcess, setBackgroundProcess] = useState(false);
//     const [filesData, setFilesData] = useState([]);
//     const [fetchedFilesData, setFetchedFilesData] = useState([]);
//     const [logsData, setLogsData] = useState([]);
//     const [processedFiles, setProcessedFiles] = useState([]);
//     const [unprocessedFiles, setUnProcessedFiles] = useState([]);
//     const [serverStatus, setServerStatus] = useState(false);
//     const [serviceUrl, setServiceUrl] = useState("");
//     const [serverLoadState, setServerLoadState] = useState(true);
//     const [Loader, setLoader] = useState(true);
//     const [processOption, setProcessOption] = useState("normal");
//     const [serverOFF, setServerOFF] = useState(false);
//     const [startIndex, setStartIndex] = useState(undefined);
//     const [endIndex, setEndIndex] = useState(undefined);
//     const [rowSelection, setRowSelection] = useState({});
//     const [fslstartIndex, setfslStartIndex] = useState(undefined);
//     const [fslendIndex, setfslEndIndex] = useState(undefined);
//     const [fslrowSelection, setfslRowSelection] = useState({});

//     let [isOpenPopup, setIsOpenPopup] = useState(false);
//     let [msg, setMsg] = useState(false);
//     let [isSuccess, setIsSuccess] = useState(false);

//     function closePopup() {
//         setIsOpenPopup(false);
//     }

//     const openPopup = useCallback(() => {
//         setIsOpenPopup(true);
//     }, [setIsOpenPopup]);

//     const handleStartProcess = async (data) => {
//         if (processOption === "normal") {
//             setStartProcess(true);

//             const initialFiles = data.map((file) => {
//                 return { ...file, status: null, creation_date: "" };
//             });

//             setFilesData(initialFiles);
//             setLogsData([]);

//             const currentLogs = [];
//             const updatedProcessedFiles = [];
//             const updatedUnprocessedFiles = [];

//             for (let i = 0; i < data.length; i++) {
//                 let startdt = formattedStartDateTime();
//                 let file = data[i];
//                 file.status = "Inprogress";
//                 file.start_date_time = startdt;
//                 file.creation_date = "";
//                 setFilesData((prevData) => {
//                     const newData = [...prevData];
//                     newData[i] = file;
//                     return newData;
//                 });
//                 try {
//                     const response = await axios.post(
//                         `${API_URL}/GetIdeas/process/${sessionStorage.getItem(
//                             "projectCode"
//                         )}`,
//                         {
//                             id: file.id,
//                             filename: file.filename,
//                         },
//                         {
//                             headers: {
//                                 Authorization: `Bearer ${localStorage.getItem(
//                                     "access_token"
//                                 )}`,
//                             },
//                         }
//                     );
//                     if (response.data.status === "success") {
//                         // Update the status of the current file to "success"
//                         file.status = "success";
//                         file.response = response.data.response;
//                         const date = new Date();
//                         file.creation_date = date;
//                         currentLogs.push({
//                             filename: file.filename,
//                             creation_date: date,
//                             ...response.data,
//                         });
//                         updatedProcessedFiles.push(file); // Add to processedFiles
//                     } else {
//                         // Update the status of the current file to "error"
//                         file.status = "error";
//                         file.response = response.data.response;
//                         const errordate = new Date();
//                         file.creation_date = errordate;
//                         currentLogs.push({
//                             filename: file.filename,
//                             creation_date: errordate,
//                             ...response.data,
//                         });
//                         updatedUnprocessedFiles.push(file); // Add to unprocessedFiles
//                     }
//                 } catch (error) {
//                     // Update the status of the current file to "error"
//                     file.status = "error";
//                     const errordate = new Date();
//                     file.creation_date = errordate;
//                     const errorMessage = handleApiError(error);
//                     if (errorMessage !== "CoreAPIError") {
//                         currentLogs.push({
//                             filename: file.filename,
//                             creation_date: errordate,
//                         });
//                         setMsg(errorMessage);
//                         setIsSuccess(false);
//                         openPopup();
//                     } else {
//                         file.response = error.response.data.response;
//                         currentLogs.push({
//                             filename: file.filename,
//                             creation_date: errordate,
//                             ...error.response.data,
//                         });
//                     }
//                     updatedUnprocessedFiles.push(file); // Add to unprocessedFiles
//                 }

//                 setFilesData((prevData) => {
//                     const newData = [...prevData];
//                     newData[i] = file;
//                     return newData;
//                 });
//             }

//             // Update the state with the updatedFiles array
//             setLogsData(currentLogs);
//             setProcessedFiles(updatedProcessedFiles); // Update processedFiles state
//             setUnProcessedFiles(updatedUnprocessedFiles); // Update unprocessedFiles state
//             setStartProcess(false);
//         } else {
//             // code for background process
//             setBackgroundProcess(true);
//             const fileIds = data.map((file) => file.id);
//             try {
//                 const response = await axios.post(
//                     `${API_URL}/GetIdeas/background/${sessionStorage.getItem(
//                         "projectCode"
//                     )}`,
//                     {
//                         files: fileIds,
//                         serverState: serverOFF
//                     },
//                     {
//                         headers: {
//                             Authorization: `Bearer ${localStorage.getItem(
//                                 "access_token"
//                             )}`,
//                         },
//                     }
//                 );
//                 if (response) {
//                     setMsg(response.data.message);
//                     setServerStatus(response.data.serverStatus);
//                     setIsSuccess(true);
//                     openPopup();
//                 }
//             } catch (error) {
//                 const errorMessage = handleApiError(error);
//                 setMsg(errorMessage);
//                 setIsSuccess(false);
//                 openPopup();
//             }
//             setBackgroundProcess(false);
//             ReloadData();
//         }
//     };

//     useEffect(() => {
//         const fetchTranscribedData = async () => {
//             try {
//                 const response = await axios.get(
//                     `${API_URL}/GetIdeas/closedtranscriptfiles/${sessionStorage.getItem(
//                         "projectCode"
//                     )}`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${localStorage.getItem(
//                                 "access_token"
//                             )}`,
//                         },
//                     }
//                 );
//                 setFetchedFilesData(response.data.data);
//             } catch (error) {
//                 const errorMessage = handleApiError(error);
//                 setMsg(errorMessage);
//                 setIsSuccess(false);
//                 openPopup();
//             } finally {
//                 setTimeout(() => {
//                     setLoader(false);
//                 }, 100);
//             }
//         };
//         const fetchStatus = async () => {
//             try {
//                 const response = await axios.get(`${API_URL}/instancemonitor`, {
//                     headers: {
//                         Authorization: `Bearer ${localStorage.getItem(
//                             "access_token"
//                         )}`,
//                     },
//                     params: {
//                         server_instance: "IDA",
//                     },
//                 });
//                 if (response) {
//                     setServerStatus(response.data.data[0].serverStatus);
//                     setServiceUrl(response.data.data[0].service_url);
//                 }
//             } catch (error) {
//                 const errorMessage = handleApiError(error);
//                 if (errorMessage) {
//                     setServerStatus(false);
//                     setServiceUrl("");
//                 }
//             } finally {
//                 setServerLoadState(false);
//             }
//         };
//         fetchTranscribedData();
//         fetchStatus();
//     }, [setFetchedFilesData, setServerStatus, openPopup]);

//     const ReloadData = useCallback(() => {
//         setLoader(true);
//         setRowSelection({});
//         setStartIndex(undefined);
//         setEndIndex(undefined);
//         const reloadTranscribedData = async () => {
//             try {
//                 const response = await axios.get(
//                     `${API_URL}/GetIdeas/closedtranscriptfiles/${sessionStorage.getItem(
//                         "projectCode"
//                     )}`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${localStorage.getItem(
//                                 "access_token"
//                             )}`,
//                         },
//                     }
//                 );
//                 setFetchedFilesData(response.data.data);
//             } catch (error) {
//                 const errorMessage = handleApiError(error);
//                 setMsg(errorMessage);
//                 setIsSuccess(false);
//                 openPopup();
//             } finally {
//                 setTimeout(() => {
//                     setLoader(false);
//                 }, 100);
//             }
//         };
//         reloadTranscribedData();
//     }, [setFetchedFilesData, openPopup]);

//     const tabs = [
//         {
//             id: 1,
//             title: "Transcripted Files",
//             content: (
//                 <FilesToProcess
//                     serverStatus={serverStatus}
//                     ReloadData={ReloadData}
//                     items={fetchedFilesData}
//                     startProcess={startProcess}
//                     backgroundProcess={backgroundProcess}
//                     setFilesData={handleStartProcess}
//                     Loader={Loader}
//                     setProcessOption={setProcessOption}
//                     setServerOFF={setServerOFF}
//                     startIndex={startIndex}
//                     endIndex={endIndex}
//                     setStartIndex={setStartIndex}
//                     setEndIndex={setEndIndex}
//                     rowSelection={rowSelection}
//                     setRowSelection={setRowSelection}
//                 />
//             ),
//         },
//         {
//             id: 2,
//             title: "Get Ideas Process",
//             content: (
//                 <Process
//                     startProcess={startProcess}
//                     selectedFilesToProcess={filesData}
//                 />
//             ),
//         },
//         {
//             id: 3,
//             title: "Logs",
//             content: (
//                 <CurrentProcessLogs
//                     logs={logsData}
//                     processedfiles={processedFiles}
//                     unprocessedfiles={unprocessedFiles}
//                 />
//             ),
//         },
//         {
//             id: 4,
//             title: "All Files Status",
//             content: <GetIdeasFilewiseStatusLogs 
//                         startIndex={fslstartIndex}
//                         endIndex={fslendIndex}
//                         setStartIndex={setfslStartIndex}
//                         setEndIndex={setfslEndIndex}
//                         rowSelection={fslrowSelection}
//                         setRowSelection={setfslRowSelection}
//                     />,
//         },
//     ];

//     return (
//         <>
//             <Popup
//                 isOpen={isOpenPopup}
//                 msg={msg}
//                 closeModal={closePopup}
//                 isSuccess={isSuccess}
//             />
//             <ProcessLayout
//                 startProcess={startProcess}
//                 tabs={tabs}
//                 server="Idea Service"
//                 serverStatus={serverStatus}
//                 serviceUrl={serviceUrl}
//                 serverLoadState={serverLoadState}
//                 batching={false}
//             />
//         </>
//     );
// }

// export default GetIdeas;

import React, { useCallback, useEffect, useState } from "react";
import ProcessLayout from "../Common/ProcessLayout";
import { GETIDEAS_URL, PROJECT_URL } from "../../imports";
import axios from "axios";
import GetIdeasFilewiseStatusLogs from "./GetIdeasComponents/GetIdeasFilewiseStatusLogs";
import FilesToProcess from "../Common/FilesToProcess";
import Process from "../Common/Process";
import CurrentProcessLogs from "../Common/CurrentProcessLogs";
import Popup from "../Common/Popup";
import { handleApiError } from "../Common/APIUtils";
import { formattedStartDateTime } from "../Common/CommonUtils";

function GetIdeas() {
    const [startProcess, setStartProcess] = useState(false);
    const [backgroundProcess, setBackgroundProcess] = useState(false);
    const [filesData, setFilesData] = useState([]);
    const [fetchedFilesData, setFetchedFilesData] = useState([]);
    const [logsData, setLogsData] = useState([]);
    const [processedFiles, setProcessedFiles] = useState([]);
    const [unprocessedFiles, setUnProcessedFiles] = useState([]);
    const [serverStatus, setServerStatus] = useState(false);
    const [serviceUrl, setServiceUrl] = useState("");
    const [serverLoadState, setServerLoadState] = useState(true);
    const [Loader, setLoader] = useState(true);
    const [processOption, setProcessOption] = useState("normal");
    const [serverOFF, setServerOFF] = useState(false);
    const [startIndex, setStartIndex] = useState(undefined);
    const [endIndex, setEndIndex] = useState(undefined);
    const [rowSelection, setRowSelection] = useState({});
    const [fslstartIndex, setfslStartIndex] = useState(undefined);
    const [fslendIndex, setfslEndIndex] = useState(undefined);
    const [fslrowSelection, setfslRowSelection] = useState({});
    const [activeTab, setActiveTab] = useState(0);

    let [isOpenPopup, setIsOpenPopup] = useState(false);
    let [msg, setMsg] = useState(false);
    let [isSuccess, setIsSuccess] = useState(false);

    function closePopup() {
        setIsOpenPopup(false);
    }

    const openPopup = useCallback(() => {
        setIsOpenPopup(true);
    }, [setIsOpenPopup]);

    const handleStartProcess = async (data) => {
        if (processOption === "normal") {

            // let apiKey = sessionStorage.getItem("api_key") || localStorage.getItem("api_key");
            // if (!apiKey) {
            //     apiKey = prompt("Please enter your API key:");
            //     if (!apiKey) {
            //         setMsg("API key is required.");
            //         setIsSuccess(false);
            //         openPopup();
            //         return;
            //     }
            //     sessionStorage.setItem("api_key", apiKey);
            //     localStorage.setItem("api_key", apiKey);
            // }

            setStartProcess(true);
            setActiveTab(1);

            const initialFiles = data.map((file) => {
                return { ...file, status: null, creation_date: "" };
            });

            setFilesData(initialFiles);
            setLogsData([]);

            const currentLogs = [];
            const updatedProcessedFiles = [];
            const updatedUnprocessedFiles = [];

            for (let i = 0; i < data.length; i++) {
                // let startdt = formattedStartDateTime();
                let startdt = new Date().toISOString();
                let file = data[i];
                file.status = "Inprogress";
                file.start_date_time = startdt;
                file.creation_date = startdt;  // Set to start date instead of empty string
                setFilesData((prevData) => {
                    const newData = [...prevData];
                    newData[i] = file;
                    return newData;
                });
                try {
                    // Updated API call to match backend structure
                    console.log("Sending request:", {
                        project_code: sessionStorage.getItem("projectCode"),
                        file_code: file.file_code || file.id,
                        clientId: localStorage.getItem("clientId"),
                    });

                    const paramResponse = await axios.get(
                        `${PROJECT_URL}/projects/params/${sessionStorage.getItem("projectCode")}`,
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                            },
                        }
                    );

                    const getIdeasParam = paramResponse.data.data.find(
                        param => param.process_code === 'GETIDEAS' && param.status === true
                    );

                    if (!getIdeasParam) {
                        setMsg("Get Ideas parameter is not configured or active.");
                        setIsSuccess(false);
                        openPopup();
                        return;
                    }

                    // const paramConfig = JSON.parse(getIdeasParam.param_config);
                    const paramConfig = typeof getIdeasParam.param_config === 'string' 
                    ? JSON.parse(getIdeasParam.param_config) 
                    : getIdeasParam.param_config;

                    const response = await axios.post(
                        // `${serviceUrl}/get-ideas`,
                        `${GETIDEAS_URL}/get-ideas`,
                        {
                            // payload: {
                                project_code: sessionStorage.getItem("projectCode"),
                                file_code: file.file_code || file.id, // Assuming file has file_code
                                clientId: localStorage.getItem("clientId"),
                                filename: file.filename,
                                // api_key: sessionStorage.getItem("api_key") || localStorage.getItem("api_key"),
                                // Optional: Add other configuration if needed
                                // get_aliases: 1,
                                // get_ner: 1,
                                // get_feature_list: 1,
                                // get_topics: 1,
                                // get_sentiment: 1,
                                ...paramConfig,

                            // },
                            // userInfo: {
                                // clientId: localStorage.getItem("clientId"), // Store clientId in localStorage
                            // }
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );

                     // Check for error status_code
                    if (response.data.status_code && response.data.status_code < 0) {
                        throw new Error(response.data.status_message || "Processing failed");
                    }
                    
                    // Process successful response
                    file.status = "success";
                    file.response = response.data;
                    const date = new Date();
                    file.creation_date = date;
                    // currentLogs.push({
                    //     filename: file.filename,
                    //     creation_date: date,
                    //     status: "success",
                    //     response: response.data,
                    // });
                    currentLogs.push({
                        filename: file.filename,
                        creation_date: date,
                        start_date_time: file.start_date_time || null,
                        status: "success",
                        status_code: response.data.status_code,
                        status_message: response.data.status_message,
                        api_version: response.data.api_version || null,
                        response: response.data,
                    });
                    updatedProcessedFiles.push(file);
                    
                } catch (error) {
                    // Handle errors
                    file.status = "error";
                    const errordate = new Date();
                    file.creation_date = errordate;
                    let errorMessage = "";
                    
                    if (error.response && error.response.data) {
                        if (error.response.data.detail) {
                            if (typeof error.response.data.detail === 'string') {
                                errorMessage = error.response.data.detail;
                            } else if (Array.isArray(error.response.data.detail)) {
                                errorMessage = error.response.data.detail.map(e => e.msg).join(', ');
                            }
                        }
                        file.response = errorMessage || error.response.data;
                        // currentLogs.push({
                        //     filename: file.filename,
                        //     creation_date: errordate,
                        //     status: "error",
                        //     response: errorMessage || error.response.data,
                        // });
                        currentLogs.push({
                            filename: file.filename,
                            creation_date: errordate,
                            start_date_time: file.start_date_time || null,
                            status: "error",
                            status_code: error.response?.data?.status_code || "-1",
                            status_message: errorMessage || error.response?.data?.status_message || "Processing failed",
                            api_version: null,
                            response: errorMessage || error.response.data,
                        });
                    } else {
                        const errorMessage = handleApiError(error);
                        if (errorMessage !== "CoreAPIError") {
                            currentLogs.push({
                                filename: file.filename,
                                creation_date: errordate,
                                status: "error",
                                response: errorMessage,
                            });
                            setMsg(errorMessage);
                            setIsSuccess(false);
                            openPopup();
                        }
                    }
                    updatedUnprocessedFiles.push(file);
                }

                setFilesData((prevData) => {
                    const newData = [...prevData];
                    newData[i] = file;
                    return newData;
                });
            }

            // Update the state with the updatedFiles array
            setLogsData(currentLogs);
            // setProcessedFiles(updatedProcessedFiles);
            setProcessedFiles(prev => {
                const existingCodes = new Set(prev.map(f => f.file_code));
                const newOnes = updatedProcessedFiles.filter(f => !existingCodes.has(f.file_code));
                return [...prev, ...newOnes];
            });
            setUnProcessedFiles(updatedUnprocessedFiles);
            setStartProcess(false);
            setActiveTab(3);
        } else {
            // Background process - you may need to implement a batch endpoint in backend
            setBackgroundProcess(true);
            try {
                const fileRequests = data.map((file) => ({
                    project_code: sessionStorage.getItem("projectCode"),
                    file_code: file.file_code || file.id,
                    api_key: localStorage.getItem("api_key"),
                }));

                // You might need to create a batch endpoint in your backend
                // For now, this will process files sequentially in background
                const response = await axios.post(
                    `${GETIDEAS_URL}/background/${sessionStorage.getItem("projectCode")}`,
                    {
                        files: fileRequests,
                        serverState: serverOFF
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
                
                if (response) {
                    setMsg(response.data.message);
                    setServerStatus(response.data.serverStatus);
                    setIsSuccess(true);
                    openPopup();
                }
            } catch (error) {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            }
            setBackgroundProcess(false);
            ReloadData();
            setActiveTab(3);
        }
    };

    // useEffect(() => {
    //     const fetchTranscribedData = async () => {
    //         try {
    //             // const response = await axios.get(
    //             //     `${GETIDEAS_URL}/closedtranscriptfiles/${sessionStorage.getItem("projectCode")}`,
    //             //     {
    //             //         headers: {
    //             //             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //             //         },
    //             //     }
    //             // );
                
    //             const response = await axios.get(`${GETIDEAS_URL}/closedtranscriptfiles`, {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 },
    //                 params: {
    //                     project_code: sessionStorage.getItem("projectCode"),
    //                 },
    //             });
    //             setFetchedFilesData(response.data.data);
    //         } catch (error) {
    //             const errorMessage = handleApiError(error);
    //             setMsg(errorMessage);
    //             setIsSuccess(false);
    //             openPopup();
    //         } finally {
    //             setTimeout(() => {
    //                 setLoader(false);
    //             }, 100);
    //         }
    //     };
        
    //     const fetchStatus = async () => {
    //         try {
    //             // Check if the Get Ideas service is running
    //             const response = await axios.get(`${GETIDEAS_URL}/instancemonitor`, {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 },
    //                 params: {
    //                     server_instance: "IDA",
    //                 },
    //             });
    //             if (response) {
    //                 setServerStatus(response.data.data[0].serverStatus);
    //                 setServiceUrl(response.data.data[0].service_url);
    //             }
    //         } catch (error) {
    //             const errorMessage = handleApiError(error);
    //             if (errorMessage) {
    //                 setServerStatus(false);
    //                 setServiceUrl("");
    //             }
    //         } finally {
    //             setServerLoadState(false);
    //         }
    //     };
        
    //     fetchTranscribedData();
    //     fetchStatus();
    // }, [setFetchedFilesData, setServerStatus, openPopup]);

    useEffect(() => {
        const fetchTranscribedData = async () => {
            try {
                const response = await axios.get(
                    `${GETIDEAS_URL}/closedtranscriptfiles`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                        params: {
                            project_code: sessionStorage.getItem("projectCode"),
                        },
                    }
                );
                
                // DEBUG: Log the response to see what we're getting
                console.log("Fetched files response:", response.data);
                
                // Handle both response formats
                // If response.data has a 'data' property, use it; otherwise use response.data directly
                const files = response.data?.data ?? response.data ?? [];

                  // Filter for txt, csv, and json files only
                const filteredFiles = files.filter(file => {
                    const ext = file.filename?.toLowerCase().split('.').pop();
                    return ['txt', 'csv', 'json'].includes(ext);
                });

                console.log("Processed files:", filteredFiles);
                
                setFetchedFilesData(filteredFiles);
            } catch (error) {
                console.error("Error fetching files:", error);
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            } finally {
                setTimeout(() => {
                    setLoader(false);
                }, 100);
            }
        };

        // const fetchAlreadyProcessedFiles = async () => {
        //     try {
        //         const projectCode = sessionStorage.getItem("projectCode");
        //         const response = await axios.get(
        //             `${GETIDEAS_URL}/GetIdeas/filewiseLog/${projectCode}`,  // ✅ correct URL
        //             {
        //                 headers: {
        //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        //                 },
        //             }
        //         );
        //         const files = response.data?.data ?? response.data ?? [];
        //         const successFiles = files
        //             .filter(f => ["success", "SUCCESS"].includes(f.status))  // ✅ both cases
        //             .map(f => ({
        //                 ...f,
        //                 filename: f.filename || f.file_name || f.name,
        //             }));
        //         setProcessedFiles(successFiles);
        //     } catch (error) {
        //         console.log("Could not fetch processed files:", error.message);
        //     }
        // };
        const fetchAlreadyProcessedFiles = async () => {
            try {
                const projectCode = sessionStorage.getItem("projectCode");
                const response = await axios.get(
                    `${GETIDEAS_URL}/GetIdeas/filewiseLog/${projectCode}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
                const files = response.data?.data ?? response.data ?? [];
                const successFiles = files
                    .filter(f => ["success", "SUCCESS"].includes(f.status))
                    .map(f => ({ ...f, filename: f.filename || f.file_name || f.name }));
                setProcessedFiles(successFiles);

                // ✅ Pre-populate logs table
                // const allLogs = files.map(f => ({
                //     filename: f.filename || f.file_name || f.name,
                //     status: f.status,
                //     status_code: f.status_code,
                //     status_message: f.status_message,
                //     api_version: f.api_version || null,
                //     start_date_time: f.start_date_time || null,
                //     creation_date: f.creation_date || null,
                // }));
                // if (allLogs.length > 0) setLogsData(allLogs);
            } catch (error) {
                console.log("Could not fetch processed files:", error.message);
            }
        };
        
        const fetchStatus = async () => {
            try {
                const response = await axios.get(`${GETIDEAS_URL}/instancemonitor`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                    params: {
                        server_instance: "IDA",
                    },
                });
                if (response) {
                    setServerStatus(response.data.data[0].serverStatus);
                    setServiceUrl(response.data.data[0].service_url);
                }
            } catch (error) {
                console.error("Error fetching server status:", error);
                const errorMessage = handleApiError(error);
                if (errorMessage) {
                    setServerStatus(false);
                    setServiceUrl("");
                }
            } finally {
                setServerLoadState(false);
            }
        };
        
        fetchTranscribedData();
        fetchAlreadyProcessedFiles();
        fetchStatus();
    }, [setFetchedFilesData, setServerStatus, openPopup]);

    // const ReloadData = useCallback(() => {
    //     setLoader(true);
    //     setRowSelection({});
    //     setStartIndex(undefined);
    //     setEndIndex(undefined);
    //     const reloadTranscribedData = async () => {
    //         try {
    //             // const response = await axios.get(
    //             //     `${GETIDEAS_URL}/closedtranscriptfiles/${sessionStorage.getItem("projectCode")}`,
    //             //     {
    //             //         headers: {
    //             //             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //             //         },
    //             //     }
    //             // );
    //             const response = await axios.get(`${GETIDEAS_URL}/closedtranscriptfiles`, {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 },
    //                 params: {
    //                     project_code: sessionStorage.getItem("projectCode"),
    //                 },
    //             });
    //             setFetchedFilesData(response.data.data);
    //         } catch (error) {
    //             const errorMessage = handleApiError(error);
    //             setMsg(errorMessage);
    //             setIsSuccess(false);
    //             openPopup();
    //         } finally {
    //             setTimeout(() => {
    //                 setLoader(false);
    //             }, 100);
    //         }
    //     };
    //     reloadTranscribedData();
    // }, [setFetchedFilesData, openPopup]);

    const ReloadData = useCallback(() => {
        setLoader(true);
        setRowSelection({});
        setStartIndex(undefined);
        setEndIndex(undefined);
        
        const reloadTranscribedData = async () => {
            try {
                const response = await axios.get(
                    `${GETIDEAS_URL}/closedtranscriptfiles`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                        params: {
                            project_code: sessionStorage.getItem("projectCode"),
                        },
                    }
                );
                
                // DEBUG: Log the response
                console.log("Reloaded files response:", response.data);
                
                // Handle both response formats
                const files = response.data?.data ?? response.data ?? [];

                 // Filter for txt, csv, and json files only
                const filteredFiles = files.filter(file => {
                    const ext = file.filename?.toLowerCase().split('.').pop();
                    return ['txt', 'csv', 'json'].includes(ext);
                });

                console.log("Reloaded processed files:", filteredFiles);
                
                setFetchedFilesData(filteredFiles);
            } catch (error) {
                console.error("Error reloading files:", error);
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            } finally {
                setTimeout(() => {
                    setLoader(false);
                }, 100);
            }
        };

        // const reloadProcessedFiles = async () => {
        //     try {
        //         const projectCode = sessionStorage.getItem("projectCode");
        //         const response = await axios.get(
        //             `${GETIDEAS_URL}/filewisestatusrpt/${projectCode}`,
        //             {
        //                 headers: {
        //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        //                 },
        //             }
        //         );
        //         const files = response.data?.data ?? response.data ?? [];
        //         const successFiles = files
        //             .filter(f => ["success", "Success"].includes(f.status))
        //             .map(f => ({
        //                 ...f,
        //                 filename: f.filename || f.file_name || f.name,
        //             }));
        //         setProcessedFiles(successFiles);
        //     } catch (error) {
        //         console.log("Could not fetch processed files:", error.message);
        //     }
        // };

        const reloadProcessedFiles = async () => {
            try {
                const projectCode = sessionStorage.getItem("projectCode");
                const response = await axios.get(
                    `${GETIDEAS_URL}/GetIdeas/filewiseLog/${projectCode}`,  // ✅ correct URL
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
                const files = response.data?.data ?? response.data ?? [];
                const successFiles = files
                    .filter(f => ["success", "SUCCESS"].includes(f.status))
                    .map(f => ({ ...f, filename: f.filename || f.file_name || f.name }));
                setProcessedFiles(successFiles);

                // ✅ Keep logs in sync on reload
                // const allLogs = files.map(f => ({
                //     filename: f.filename || f.file_name || f.name,
                //     status: f.status,
                //     status_code: f.status_code,
                //     status_message: f.status_message,
                //     api_version: f.api_version || null,
                //     start_date_time: f.start_date_time || null,
                //     creation_date: f.creation_date || null,
                // }));
                // if (allLogs.length > 0) setLogsData(allLogs);
            } catch (error) {
                console.log("Could not fetch processed files:", error.message);
            }
        };

        reloadTranscribedData();
        reloadProcessedFiles();
    }, [setFetchedFilesData, openPopup]);

    const tabs = [
        {
            id: 1,
            title: "Transcripted Files",
            content: (
                <FilesToProcess
                    serverStatus={serverStatus}
                    ReloadData={ReloadData}
                    items={fetchedFilesData}
                    startProcess={startProcess}
                    backgroundProcess={backgroundProcess}
                    setFilesData={handleStartProcess}
                    Loader={Loader}
                    setProcessOption={setProcessOption}
                    setServerOFF={setServerOFF}
                    startIndex={startIndex}
                    endIndex={endIndex}
                    setStartIndex={setStartIndex}
                    setEndIndex={setEndIndex}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    hideQdbColumn={true}
                    process_code="GETIDEAS"
                />
            ),
        },
        {
            id: 2,
            title: "Get Ideas Process",
            content: (
                <Process
                    startProcess={startProcess}
                    selectedFilesToProcess={filesData}
                />
            ),
        },
        // {
        //     id: 3,
        //     title: "Logs",
        //     content: (
        //         <CurrentProcessLogs
        //             logs={logsData}
        //             processedfiles={processedFiles}
        //             unprocessedfiles={unprocessedFiles}
        //         />
        //     ),
        // },
        {
            id: 3,
            title: "Logs",
            content: (
                <CurrentProcessLogs
                    logs={logsData}
                    processedfiles={processedFiles}
                    unprocessedfiles={fetchedFilesData.filter(f =>
                        (f.status || "").toLowerCase() === "uploaded"
                    )}
                />
            ),
        },
        {
            id: 4,
            title: "All Files Status",
            content: <GetIdeasFilewiseStatusLogs 
                        startIndex={fslstartIndex}
                        endIndex={fslendIndex}
                        setStartIndex={setfslStartIndex}
                        setEndIndex={setfslEndIndex}
                        rowSelection={fslrowSelection}
                        setRowSelection={setfslRowSelection}
                    />,
        },
    ];

    return (
        <>
            <Popup
                isOpen={isOpenPopup}
                msg={msg}
                closeModal={closePopup}
                isSuccess={isSuccess}
            />
            <ProcessLayout
                startProcess={startProcess}
                tabs={tabs}
                server="Idea Service"
                serverStatus={serverStatus}
                serviceUrl={serviceUrl}
                serverLoadState={serverLoadState}
                batching={false}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
        </>
    );
}

export default GetIdeas;

